import defaultAxios from "lib/http/http.common"
import {NoneOperationComment} from "dto/realdevice/none-operation-comment"
import dayjs from "dayjs"
import {ApiResponse, PageableListResponse} from "api/common/response"

let dateFormat = 'YYYY-MM-DD'
const createNoneOperComment = async (eui: string, from: Date, end: Date, comment: string) => {
    const data = {
        eui: eui,
        fromDate: dayjs(from).format(dateFormat),
        toDate: dayjs(from).format(dateFormat),
        comment: comment
    }
    await defaultAxios.post("/device/none-operation-comment", data)
}

const updateNoneOperComment = async (id: number, eui: string, from: Date, end: Date, comment: string) => {
    const data = {
        eui: eui,
        fromDate: dayjs(from).format(dateFormat),
        toDate: dayjs(end).format(dateFormat),
        comment: comment
    }
    await defaultAxios.put<NoneOperationComment>(`/device/none-operation-comment/${id}`, data)
}

const deleteNoneOperComment = async (id: number) => {
    await defaultAxios.delete(`/device/none-operation-comment/${id}`)
}

const findAllNoneOperCommentByEui = async (eui: string, page: number = 0, size: number = 10) => {
    return defaultAxios.get(`/device/none-operation-comment/eui/${eui}?page=${page}&size=${size}`)
}

const findNoneOperCommentById = async (id: number) => {
    return defaultAxios.get(`/device/none-operation-comment/${id}`)
}

export const NoneOperationCommentApi = {
    createNoneOperComment,
    updateNoneOperComment,
    deleteNoneOperComment,
    findAllNoneOperCommentByEui,
    findNoneOperCommentById
}